import { Injectable, TemplateRef } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MdbModalConfig, MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MdbModalWrapperService {

    private counter: number = 0;

    constructor(
        private modalService: MdbModalService,
    ) { }

    open(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>, config?: MdbModalConfig<{
        data: any;
    }>): MdbModalRef<unknown> {
        this.counter++;

        const modalRef = this.modalService.open(componentOrTemplateRef, config);
        modalRef.onClose.pipe(
            first()
        ).subscribe(() => {
            this.counter--;

            const body = window['$'](document.body);
            if(this.counter > 0) {
                body.addClass('modal-open');
            }
        });

        return modalRef;
    }
}
